import { SourcesOfIncomeFormType } from 'modules/onboarding/common/forms/sourcesOfIncomeForm';
import { useClientSourcesOfIncome } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useOwnerSourcesOfIncome = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();

  const {
    files,
    initialValues,
    saveSourcesOfIncome,
    submitLoading,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
  } = useClientSourcesOfIncome(data.ownerClient!);

  const onSubmit = async (values: SourcesOfIncomeFormType) => {
    if (values) {
      await saveSourcesOfIncome(values);
      goToNext();
    }
  };

  return {
    onSubmit,
    goToBack,
    submitLoading,
    initialValues,
    files,
    submitDisabled,
    onAddFiles,
    onRemoveFile,
  };
};
